import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { getSortableDate, getSortableTime } from 'src/app/utlis';

@Component({
  selector: 'app-hold-report-v2',
  templateUrl: './hold-report-v2.component.html',
  styleUrls: ['./hold-report-v2.component.scss'],
})
export class HoldReportV2Component implements OnInit, AfterViewInit {
  apptId: any;
  buttonText: string = 'Receive Payment';

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private authService: AuthenticationService,
    private router: Router
  ) {}
  paymentAmount!: any;
  value: String = 'Upcoming';
  appointments: any = [];
  userRole: any;
  status!: string;
  filterForm!: FormGroup;
  tests: any;
  surveys: any;
  selectedTests: any;
  selectedSurveys: any;
  show: boolean = false;
  scheduleId: any;

  ngAfterViewInit(): void {
    this.dtTrigger.next(this);
  }
  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(this);
    });
  }

  ngOnInit(): void {
    this.show = false;
    let location = null;
    let diagId = null;
    let status = 'HOLD';
    this.spinner.show();
    this.userRole = this.authService.getUserType();
    if (this.userRole != 'ADMIN' && this.userRole != 'DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }
    this.appointmentService
      .getAppointments(location, diagId, status, null, null, null)
      .subscribe((res: any) => {
        this.appointments = res.data;

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        }

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };
        this.rerender();

        this.show = true;
        this.spinner.hide();
      });

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    });
  }
  updateApptId(id: any) {
    this.apptId = id;
  }

  HoldAndUnHoldAppt(action: any) {
    //  let action = "HOLD"
    this.appointmentService
      .updateAppts(action, this.apptId, null, null)
      .subscribe((res) => {
        this.router.navigate(['/appt-all-details', this.apptId]);
      });
  }

  submitFilterForm() {
    this.spinner.show();
    this.appointmentService
      .getAppointments(
        null,
        null,
        'HOLD',
        null,
        this.filterForm.controls['fromDate'].value,
        this.filterForm.controls['toDate'].value
      )
      .subscribe((res: any) => {
        this.appointments = res.data;

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        }

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };

        this.rerender();
        this.show = true;
        this.spinner.hide();
      });
  }

  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
  setApptId(apptId: any) {
    this.apptId = apptId;
  }

  submitPayment() {
    this.appointmentService
      .updateAppts('FOLLOWUP', this.apptId, null, null)
      .subscribe((res) => {});
  }
  redirectHome() {
    location.reload();
  }

  getSortableTime(timeRangeStr: string) {
    return getSortableTime(timeRangeStr);
  }

  getSortableDate(dateStr: string): string {
    return getSortableDate(dateStr);
  }
}
